import React, { useState, useRef, useEffect, CSSProperties } from "react";

type DropdownMenuProps = {
  options: any;
  icon: React.ReactNode;
  item?: any; // Optional
  label?: string;
  classname?: string; // For Tailwind classes
  customContainerStyle?: CSSProperties; // For inline styles
};

const DropdownMenu = ({
  options,
  icon,
  item,
  label,
  classname = "",
  customContainerStyle = {},
}: DropdownMenuProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      className={`relative inline-block `}
      style={customContainerStyle}
      ref={dropdownRef}
    >
      {/* Icon Trigger */}
      <div
        onClick={toggleDropdown}
        className={`cursor-pointer flex text-xl text-gray-500 gap-2 border-2 px-4 rounded-full ${classname}`}
      >
        {label} {icon}
      </div>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="absolute right-6 top-[30px] w-auto bg-white border rounded-md shadow-lg z-50 min-w-[200px]">
          <ul className="py-2 text-sm text-gray-700">
            {options.map((option: any, idx: number) => (
              <li key={idx}>
                <button
                  onClick={() => {
                    setIsOpen(false);
                    if (option?.returnBy) {
                      option.onClick(item[option?.returnBy]);
                    } else if (option?.returnAll) {
                      option.onClick(item);
                    } else {
                      option.onClick();
                    }
                  }}
                  className="w-full text-left px-4 py-2 hover:bg-gray-100 flex"
                >
                  {option.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default DropdownMenu;
